var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('input-email', {
    ref: "email",
    attrs: {
      "data-test": "loginFormEmailInput",
      "input-id": "input-email",
      "input-name": _vm.$t('common.login'),
      "input-title": _vm.$t('indicate.electronic.mail'),
      "input-placeholder": _vm.$t('common.email'),
      "min-length": 6,
      "disabled": _vm.loading
    },
    model: {
      value: _vm.email,
      callback: function callback($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  }), _c('input-password', {
    ref: "password",
    attrs: {
      "data-test": "loginFormPasswordInput",
      "input-id": "input-password",
      "input-name": _vm.$t('common.password'),
      "input-title": _vm.$t('enter.password.minimum.six.symbols'),
      "input-placeholder": "••••••",
      "min-length": 6,
      "disabled": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "link",
      fn: function fn() {
        return [_c('a', {
          staticClass: "restore-link",
          attrs: {
            "data-test": "loginFormPasswordRestoreLink"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push({
                name: 'restore.password'
              });
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('common.remind')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.password,
      callback: function callback($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }), _c('div', {
    class: _vm.$style.submit
  }, [_c('button', {
    staticClass: "button special",
    attrs: {
      "data-test": "loginFormSubmitButton",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sign.in')) + " ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }